import { call, takeLatest } from "redux-saga/effects";
import * as reportApis from "../apis/reportApis"
import { INVENTORY_REPORT, PRODUCT_SALES_REPORT, STOCK_IN_REPORT } from "../actions/types";


export function* inventoryReportWorker(action) {
    try {
        const res = yield call(reportApis.inventoryReportApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* stockInReportWorker(action) {
    try {
        const res = yield call(reportApis.stockInReportApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* productSalesReportWorker(action) {
    try {
        const res = yield call(reportApis.productSalesReportApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* inventoryReportWatcher() {
    yield takeLatest(INVENTORY_REPORT, inventoryReportWorker);
}
export function* stockInReportWatcher() {
    yield takeLatest(STOCK_IN_REPORT, stockInReportWorker);
}
export function* productSalesReportWatcher() {
    yield takeLatest(PRODUCT_SALES_REPORT, productSalesReportWorker);
}